<template>
  <SubscriptionPricing :config="pricingConfig" />
</template>

<script>
import SubscriptionPricing from '../../../../shared/components/layout/Subscription/SubscriptionPricing.vue'

export default {
  components: {
    SubscriptionPricing
  },
  computed: {
    pricingConfig() {
      return {
        usersAllowed: parseInt(process.env.VUE_APP_USERS_ALLOWED || '0'),
        groupsAllowed: parseInt(process.env.VUE_APP_GROUPS_ALLOWED || '1'),
        starterGroups: parseInt(process.env.VUE_APP_STARTER_GROUPS || '5'),
        proGroups: parseInt(process.env.VUE_APP_PRO_GROUPS || '10'),
        businessGroups: parseInt(process.env.VUE_APP_BUSINESS_GROUPS || '20'),
        discount: parseFloat(process.env.VUE_APP_USER_DISCOUNT || '0.1')
      }
    }
  }
}
</script>
